export const fmtInt = (v: number): string => v.toLocaleString('it-IT');

export const fmtCurrency = (v: number, code = 'EUR'): string => {
  const symbol = code === 'USD' ? '$' : '€';
  // No decimals if rounded; otherwise 2
  const rounded = Math.round(v);
  if (Math.abs(v - rounded) < 0.005) {
    return `${symbol} ${rounded.toLocaleString('it-IT')}`;
  }
  return `${symbol} ${v.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtPct = (v: number): string => v.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';

export const fmtDecimal = (v: number, digits = 2): string => v.toLocaleString('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const DAY_NAMES_IT = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];

export const fmtDayLabel = (iso: string): string => {
  const d = new Date(iso + 'T00:00:00');
  const day = DAY_NAMES_IT[d.getDay()];
  return `${day} ${d.getDate()}`;
};
